export default __webpack_public_path__ + "static/media/memories_3r1c.401fa732.png";